module.exports = __webpack_public_path__ + "img/guider-bind-btn.bfbd937f.png";